import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { compose, hoistStatics, withState, lifecycle, withHandlers, withProps } from 'recompose';
import CalendlyPage from './CalendlyPage';
import ModuleService from '../../../services/module.service';
import { settingsActions } from '../../../reducers/settings';

const mapStateToProps = state => ({
  modulesSettings: state.modules.modulesSettings,
  calendlyModule: state.modules.modulesSettings[ModuleService.TYPE_CALENDLY_PAGE],
});

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
};

const enhance = compose(
  translate('portal'),
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'setIsLoading', true),
  withState('pageId', 'setPageId', null),
  withState('page', 'setPage', null),
  withProps(props => ({
    backgroundColor:
    (props.page && props.page.color) || (props.modulesSettings[ModuleService.TYPE_CALENDLY_PAGE].color ?
      props.modulesSettings[ModuleService.TYPE_CALENDLY_PAGE].color
      : props.modulesSettings[ModuleService.TYPE_CALENDLY_PAGE].default_color),
    backgroundCover: (props.page && props.page.cover && props.page.cover.id)
    || props.modulesSettings[ModuleService.TYPE_CALENDLY_PAGE].cover,
    enableCoverColor: props.page && props.page.enable_cover_color,
    title: props.calendlyModule ? props.calendlyModule.title : '',
  })),
  lifecycle({
    async componentDidMount() {
      const { setPageId, setIsLoading, calendlyModule } = this.props;
      if (calendlyModule && calendlyModule.params.appId) {
        await setPageId(calendlyModule.params.appId);
      }
      await setIsLoading(false);
    },
  }),
  withHandlers({

  }),
);

export default hoistStatics(enhance)(CalendlyPage);



// WEBPACK FOOTER //
// ./src/views/modules/calendlyPage/index.js